module.exports = __webpack_public_path__ + "static/media/preview_screen5.0ed2329a.png";